import { format, parseISO } from 'date-fns';
import dayjs from 'dayjs';
// Magic function to give us a formatted date string when we don't have any time values
//
// Normally prototyping is frowned upon, but we want to be able to use DateOnly within .NET
// for dates that we know have no time component, and DateOnly can't parse any sort of time string within the request body
Date.prototype.toJSON = function (key) {
    if (this.getHours() + this.getMinutes() + this.getSeconds() === 0) {
        return format(this, 'yyyy-MM-dd');
    }
    return this.toISOString();
};
// Generic regex to match either dates or times
var isoDateFormat = /^(\d{4})-(\d{2})-(\d{2})/;
function isIsoDateString(value) {
    return value && typeof value === 'string' && isoDateFormat.test(value);
}
export function mapDatesFromApiResponse(body) {
    if (body === null || body === undefined || typeof body !== 'object') {
        return body;
    }
    for (var _i = 0, _a = Object.keys(body); _i < _a.length; _i++) {
        var key = _a[_i];
        var value = body[key];
        if (isIsoDateString(value)) {
            var parsed = parseISO(value);
            body[key] = parsed.valueOf() ? parsed : value;
        }
        else if (typeof value === 'object') {
            mapDatesFromApiResponse(value);
        }
    }
}
export function daysFromNow(date) {
    return dayjs(date).diff(dayjs(), 'd');
}
export function dueInText(date) {
    var diff = daysFromNow(date);
    if (diff === 0)
        return "Due today";
    if (diff === 1)
        return "Due tomorrow";
    if (diff === -1)
        return "Due yesterday";
    if (diff <= -1)
        return "Due ".concat(diff * -1, " days ago");
    return "Due in ".concat(diff, " days");
}
